import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=16704080&scoped=true"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=16704080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16704080",
  null
  
)

export default component.exports